import React from 'react';
import { Link } from 'react-router-dom';

import { DotLogo, IconInfoCircle, IconLeftArrow } from '@trqk/components';

import { PATHS } from '../../constants';
import { AccountManagement, AccountManagementWrapper } from '../templates';

export const VerifyAccount = (): JSX.Element => (
    <AccountManagementWrapper>
        <AccountManagement>
            <div className="r1c1 pl-12 pt-10 rounded-tl">
                <Link to={PATHS.SIGN_IN}>
                    <IconLeftArrow width={32} />
                    Back
                </Link>
            </div>
            <div className="r1c2" />
            <div className="r1c3 rounted-tr" />
            <div className="lower-left ml-6 mr-6 self-center">
                <div className="flex justify-center items-stretch">
                    <div className="flex-initial">
                        <DotLogo />
                    </div>
                </div>
            </div>
            <div className="r2c2 bg-secondary-500 rounded-sm" />
            <div className="r2c3 rounded-tr pr-12 pl-12">
                <h2>Verify Account</h2>
                <div className="text-sm mt-4 flex justify-start">
                    <IconInfoCircle
                        addClasses="inline mr-1"
                        fillColor="highlight-orange"
                        width={30}
                    />
                    <div className="mt-1">
                        Please check your inbox for a link <br />
                        to verify your account.
                    </div>
                </div>
            </div>
            <div className="r3c2" />
            <div className="r3c3 pr-12" />
            <div className="r4c2" />
            <div className="r4c3 ml-12 mr-12 mt-5" />
        </AccountManagement>
    </AccountManagementWrapper>
);
